import http_config from '../../common/config/http_config';
import axiosInstance from '../../common/helper/axiosInterceptor';
import { SubjectModel } from './subject.model';

export const onGetSubjects = (): Promise<SubjectModel[]> => {
  return axiosInstance.get(http_config.BASE_URL + '/subject');
};

export const onSetSubject = (payload: SubjectModel): Promise<SubjectModel> => {
  return axiosInstance.post(http_config.BASE_URL + '/subject', payload);
};
